export class GiftService {
  constructor($http) {
    this.http = $http;
  }

  getWizard() {
    return this.http.get(`/api/gift/wizard`);
  }

  getBirthday() {
    return this.http.get(`/api/gift/birthday`);
  }

  getLastVisit() {
    return this.http.get(`/api/gift/last-visit`);
  }

  getLastActive() {
    return this.http.get(`/api/gift/last-active`);
  }

  getBoost() {
    return this.http.get(`/api/gift/boost`);
  }

  getEaster() {
    return this.http.get(`/api/gift/easter`);
  }
}
